import { render } from "./circle-info-icon.vue.js?vue&type=template&id=24d504dd!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./circle-info-icon.vue?vue&type=template&id=24d504dd"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__